import styled from 'styled-components';
import { Link } from 'gatsby';
import { initialLinkStyles } from '~base-theme';
var TitleLink = styled(Link).withConfig({
  displayName: "TitleLink",
  componentId: "l5yj83-0"
})(["", ""], initialLinkStyles);
export default TitleLink;